export const CELL_TYPES = {
  HORSE: 'horse',
  ALL_SELECT_BUTTON: 'allSelectButton',
  LEG_NO: 'legNo'
};

export const BOX_TYPES = {
  LEG: 'LEG',
  RACE: 'RACE',
  HORSE: 'HORSE'
};
